import React, { Component } from "react";
import { Grid } from "@mui/material";
import CreatePassword from "./CreatePassword";
import { connect } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { forgottenPasswordResetBegin } from "../actions/forgottenpasswordactions";
import { moveToLoginPage } from "../actions/routeactions";

class ForgottenPasswordReset extends Component {
  state = {
    code: null,
    password: null,
    securityAnswer: "",
  };

  constructor(props) {
    super(props);

    this.changeProperty = this.changeProperty.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.renderSpinner = this.renderSpinner.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.backToLogin = this.backToLogin.bind(this);
  }

  changeProperty(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  resetPassword() {
    const { dispatch, email } = this.props;
    const { code, password, securityAnswer } = this.state;
    dispatch(
      forgottenPasswordResetBegin(email, code, password, securityAnswer)
    );
  }

  renderSpinner() {
    const { loading } = this.props;
    return (
      <ClipLoader color="#FFFFFF" sizeUnit={"%"} size={100} loading={loading} />
    );
  }

  backToLogin() {
    const { dispatch } = this.props;
    dispatch(moveToLoginPage());
  }

  renderButton() {
    return (
      <React.Fragment>
        <button className="bbe-button" onClick={this.resetPassword}>
          Reset Password
        </button>
        <p className="hyperlink" onClick={this.backToLogin}>
          <u>Sign in?</u>
        </p>
      </React.Fragment>
    );
  }

  render() {
    const { loading, securityQuestion } = this.props;

    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form login_form">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2>Reset Password</h2>
            </Grid>
            <Grid item xs={12}>
              <label className="label">Code</label>
            </Grid>
            <Grid item xs={12}>
              <input
                type="text"
                name="code"
                className="textbox logintext"
                onChange={this.changeProperty}
              />
              <p>Code was sent to your email, if it is registered.</p>
            </Grid>
            <Grid item xs={12}>
              <label className="label">New Password</label>
            </Grid>
            <CreatePassword updatePassword={this.changeProperty} />
            <Grid item xs={12}>
              <h3>{securityQuestion}</h3>
            </Grid>
            <Grid item xs={12}>
              <input
                type="text"
                name="securityAnswer"
                className="textbox logintext"
                onChange={this.changeProperty}
              />
            </Grid>
            <Grid item xs={12}>
              {loading ? this.renderSpinner() : this.renderButton()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.forgottenPasswordReset.loading,
});

export default connect(mapStateToProps)(ForgottenPasswordReset);
